<template>
  <cms-shell :data="data" title="Karte" @up="$emit('up', -1, data)" @down="$emit('down', 1, data)" @remove="$emit('remove', data)">
  </cms-shell>
</template>

<script>
    import CmsShell from "./CmsShell";
    export default {
      components: {CmsShell},
      name: "cms-map",
      props:['data']
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cms/CmsMap.vue